<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleDocumenti > 0"
      item-key="_id"
      :headers="headers"
      :items="documenti"
      :options.sync="options"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :show-expand="true"
      dense
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Seleziona i documenti da fatturare</v-toolbar-title>
        <v-btn class = "ml-5" small color="success" @click.stop="onAggiungiTutti">Aggiungi tutti</v-btn>
      </v-toolbar>
    </template>
    <template v-slot:[`item._id`]="{ item }">
      <span :class="isContoVisione(item) ? 'red--text' : ''">{{ isFatturata(item) ? '* ' : '' }}{{ item._id}}{{ isContoVisione(item) ? '  (conto visione)' : '' }}</span>
    </template>    
    <template v-slot:[`item.data`]="{ item }">
      {{ item.data | date }}
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="ddtSelected">
        <v-tabs dense v-model="tab">
          <v-tab>Elenco righe{{item.name}}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <dettaglio-documento :idDocumento="item._id"/>
          </v-tab-item>
        </v-tabs-items>
      </td>
    </template>
    <template v-slot:no-data>
      Nessun dato presente... Hai selezionato i clienti ?
    </template>    
    </v-data-table>  
  </div>
</template>

<script>
  import _ from 'lodash'
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import DettaglioDocumento from './sceltaDdtDettaglio.vue'
  import documenti from '@/services/documentiService.js'

  export default {
    components: {
      DettaglioDocumento
    },
    props: {
      idsClienti: Array,
      bollettari: Array,
      dateDdt: Object
    },
    data () {
      return {
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        totaleDocumenti: 0,
        documenti: [],
        selected: [],
        loading: false,
        options: {},
        headers: [
          { text: 'Tipo', value: 'tipoDocumento.descrizione', align: 'start'},
          { text: 'Numero', value: '_id'},
          { text: 'Data', value: 'data' },
          { text: 'Codice cliente', value: 'anagrafica.cliente.codice' },
          { text: 'Ragione sociale', value: 'anagrafica.cliente.descrizione' },
          { text: '', value: 'data-table-expand' }
        ],
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: null
      }
    },
    computed: {
      refreshList() {
        // console.log('refreshList')
        return this.$store.getters['documenti/refreshMultiple']
      },
      documentiSorted() {
        const els = this.documenti
        const elSorted = els.sort(dynamicSortMultiple('_id'))
        return elSorted
      }
    },
    watch: {
      options: {
        async handler () {
          // await this.getDataFromApi()
        },
        deep: true
      },
      async refreshList(value) {
        if (value) {
          await this.getDataFromApi()
          this.$store.commit('documenti/CLEAR_REFRESH', 'multiple')
        }
      },
      selected(value) {
        this.$emit('selezione', value)
      }
    },
    async mounted () {
      // await this.getDataFromApi()
    },
    methods: {
      isContoVisione(item) {
        return item && (_.get(item, 'spedizione.causale', '') === 'Conto visione')
      },
      isFatturata(item) {
        return item && (_.get(item, 'tipoDocumento.fatturaRiepilogativa', ''))
      },
      onAggiungiTutti() {
        this.selected = [...this.documenti]
      },
      async getDataFromApi () {
        if (this.idsClienti.length === 0) {
          this.documenti = []
          this.totaleDocumenti = 0
          return
        }
        try {
          this.loading = true
          const filtri = { nominativo: this.idsClienti, tipoDocumento: ['ddt'], bollettario: this.bollettari, ...this.dateDdt, nonFatturata: this.dateDdt.soloNonFatturate }
          const data = await documenti.getFilteredDocumentHeaders(filtri)
          this.documentiRaw = data && data.total_rows > 0 ? data.rows : []
          this.documenti = this.datiVisualizzazione(this.documentiRaw)
          this.totaleDocumenti = data.total_rows
        } catch(err) {
          this.documenti = []
          this.totaleDocumenti = 0
        } finally {
          this.annullaSelezione()
          this.loading = false
        }
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
      },
      datiVisualizzazione(documenti) {
        const elaborati = documenti.map(el => {
         // const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)
          const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)
          return { ...el, c_nominativo: nominativo }
        })
        return elaborati
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }

</style>
